import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useGetFormData } from "../../Administration/FillableForms/hooks/useGetFormData";
import { useAppDispatch } from "../../../store";
import { sendFormForReview } from "../../../acions/administration/fillableForms";

export const useSendForm = (contractNumber: string, form: FormInstance) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { getFormData } = useGetFormData();

  const send = useCallback(async () => {
    try {
      const values: any = await form.validateFields();

      setIsLoading(true);

      const data = getFormData(values);

      await Promise.resolve(dispatch(sendFormForReview(contractNumber, data)));

      form.resetFields();

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [contractNumber, dispatch, form, getFormData]);

  return { isLoading, send };
};
